import { render, staticRenderFns } from "./threejs12.vue?vue&type=template&id=0b428b87&scoped=true"
import script from "./threejs12.vue?vue&type=script&lang=js"
export * from "./threejs12.vue?vue&type=script&lang=js"
import style0 from "./threejs12.vue?vue&type=style&index=0&id=0b428b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b428b87",
  null
  
)

export default component.exports